import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification-change-termin",
  "use": "notification-change-termin-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"notification-change-termin\">\n  <path fill-rule=\"evenodd\" d=\"M577.666,327.368h-1.333V326H575v1.364h-3.334V326h-1.333v1.364H567V326h-1.334v1.364H564.33A1.35,1.35,0,0,0,563,328.732v10.91a1.35,1.35,0,0,0,1.333,1.363h13.336A1.35,1.35,0,0,0,579,339.642v-10.91A1.351,1.351,0,0,0,577.666,327.368Zm0,12.274H564.33v-8.183h13.336v8.183Zm0-9.547H564.33v-1.363h13.336V330.1Z\" transform=\"translate(-563 -326)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notification-change-termin.svg
// module id = null
// module chunks = 